import api from './api';

const API_BASE_URL = process.env.REACT_APP_API_URL || (
  process.env.NODE_ENV === 'production' 
    ? '/api' 
    : 'http://localhost:5000/api'
);

const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const WORKFLOW_ITEM_TYPE_OPTIONS = ['Books', 'Stamps', 'Postcards', 'Maps', 'Prints and Posters', 'FDC'];

export function normalizeWorkflowItemType(value: string | null | undefined): string {
  if (!value?.trim()) return WORKFLOW_ITEM_TYPE_OPTIONS[0];
  const lower = value.trim().toLowerCase();
  if (lower === 'maps and prints') return 'Maps';
  const found = WORKFLOW_ITEM_TYPE_OPTIONS.find((o) => o.toLowerCase() === lower);
  return found ?? WORKFLOW_ITEM_TYPE_OPTIONS[0];
}

export interface Workflow {
  id: number;
  name: string;
  description: string;
  workflow_type: string;
  workflow_json: {
    type?: string;
    model?: string;
    prompt?: string;
    supportedTypes?: string[];
    outputs?: string[];
    nodes?: any[];
    edges?: any[];
  };
  is_active: boolean;
  created_by: number | null;
  created_at: string;
  updated_at: string;
}

export const getTriageWorkflow = async (): Promise<Workflow> => {
  const response = await api.get(`${API_BASE_URL}/workflows/triage`, {
    headers: getAuthHeaders()
  });
  return response.data;
};

export const getAllWorkflows = async (): Promise<Workflow[]> => {
  const response = await api.get(`${API_BASE_URL}/workflows`, {
    headers: getAuthHeaders()
  });
  return response.data;
};

export const getWorkflowById = async (id: number): Promise<Workflow> => {
  const response = await api.get(`${API_BASE_URL}/workflows/${id}`, {
    headers: getAuthHeaders()
  });
  return response.data;
};

export const updateWorkflow = async (id: number, data: Partial<Workflow>): Promise<Workflow> => {
  const response = await api.put(`${API_BASE_URL}/workflows/${id}`, data, {
    headers: getAuthHeaders()
  });
  return response.data;
};

export const createWorkflow = async (data: Omit<Workflow, 'id' | 'created_at' | 'updated_at' | 'created_by'>): Promise<Workflow> => {
  const response = await api.post(`${API_BASE_URL}/workflows`, data, {
    headers: getAuthHeaders()
  });
  return response.data;
};

export const deleteWorkflow = async (id: number): Promise<void> => {
  await api.delete(`${API_BASE_URL}/workflows/${id}`, {
    headers: getAuthHeaders()
  });
};
